import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-light-svg-icons/faUser';
import type { OutreachPitchKind } from 'fym-shared/src/music24/outreach/dailyPitches';
import { TypedMemo } from '../../../common/types';
import { KIND_COPY } from '../campaigns/kindCopy';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the campaign page; each part uses its own slice of it */
import styles from './Campaign.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The picture of a pitched person, else the icon of the pitch kind (a person icon for an import). */
const PitchKindCoverComponent: React.FC<{ coverUrl: string | null; kind: OutreachPitchKind | null }> = ({
  coverUrl,
  kind,
}) => {
  const [failed, setFailed] = useState<string | null>(null);
  return (
    <span className={styles.cover} aria-hidden>
      {coverUrl !== null && coverUrl !== failed ? (
        <img src={coverUrl} alt="" onError={() => setFailed(coverUrl)} />
      ) : (
        <FontAwesomeIcon icon={kind === null ? faUser : KIND_COPY[kind].icon} />
      )}
    </span>
  );
};

export const PitchKindCover = TypedMemo(PitchKindCoverComponent);
